<h2 class="mt-5 mb-4">
  <ng-container i18n="Create Mail label">{{
    "createMessage" | transloco
  }}</ng-container>
</h2>
<app-mail-form (MailSubmit)="post($event)"></app-mail-form>
